import { Loader } from '@/app/components/search/components/Card/Loaders/styled.ts';
import React from 'react';

type PriceLoaderProps = {
  isOverlay: boolean;
};

const PriceLoader = ({ isOverlay }: PriceLoaderProps) => {
  if (isOverlay) {
    return (
      <>
        <Loader elWidth={77} elHeight={22} style={{ marginBottom: 4 }} />
        <Loader elWidth={149} elHeight={20} style={{ marginBottom: 4 }} />
      </>
    );
  }

  return (
    <>
      <Loader elWidth={105} elHeight={32} style={{ marginBottom: 4, marginTop: 16 }} />
      <Loader elWidth={149} elHeight={20} />
    </>
  );
};

export default PriceLoader;
